import React, { useState } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { useAtom } from 'jotai';
import {
    activeChildDetail,
    appConstants,
    bell,
    childList,
    parentProfile,
    userstate,
    mobileAtom,
    permaStatus,
    alertModal
} from '../../atomstore/store';
import Dropdown from '../common/Dropdown';
import { useNavigate } from 'react-router-dom';
import { PushNotifications } from '@capacitor/push-notifications';
import { useRequestProcessor } from '../../requestProcessor';
import { getDeviceToken } from '../../atomstore/serviceAtoms';
import { saveToken } from '../../queryfunctions/queryfunctions';
import NotificationService from '../common/NotificationService';
import Constants from "../../constant";

const TopBar = () => {
    const navigate = useNavigate();
    const [activeChild, setActiveChild] = useAtom(activeChildDetail);
    const [bellStatus, setBellStatus] = useAtom(bell);
    const [childlist] = useAtom(childList);
    const [parent] = useAtom(parentProfile);
    const [user, setUser] = useAtom(userstate);
    const [constantsValues] = useAtom(appConstants);
    const [mobile] = useAtom(mobileAtom);
    const [permStatus, setPermStatus] = useAtom(permaStatus);
    const [showModal, setShowModal] = useAtom(alertModal);
    const [showNotificationService, setShowNotificationService] = useState(false);
    const [imageError, setImageError] = useState(false);
    const { useMutationWrapper } = useRequestProcessor();

    const saveTokenFn = useMutationWrapper(
        "saveToken",
        (token) => saveToken(token),
        { onSuccess: () => console.log('Token saved') }
    );

    const getFullPath = (constants, path) => {
        if (typeof path === "string" && path.startsWith("https")) return path;
        if (!path) return "";
        return constants?.ImagePath + path;
    };

    const handleChildChange = (e) => {
        const newIndex = Number(e.target.value);
        const newChild = childlist[newIndex];
        setActiveChild(newChild);
        parent.parentType === 'Mother'
            ? setUser({ ...user, password: newChild?.father_password })
            : setUser({ ...user, password: newChild?.father_password });
    };

    // Get device token depending on platform
    let dbDeviceToken = "";
    if (Constants.env.web === "yes") {
        dbDeviceToken = activeChild?.parent === "Father"
            ? activeChild?.father_web_token
            : activeChild?.mother_web_token;
    } else {
        dbDeviceToken = activeChild?.parent === "Father"
            ? activeChild?.father_arn
            : activeChild?.mother_arn;
    }
    console.log("dbDeviceToken", dbDeviceToken)

    const handleNotificationClick = async () => {
        if (permStatus?.receive === "granted" && dbDeviceToken) {
            setBellStatus(false);
            navigate('/notifications');
        } else {
            navigate('/notifications');
            try {
                let permissionStatus;
                if (mobile) {
                    permissionStatus = await PushNotifications.requestPermissions();
                } else {
                    console.log("inside this ")
                    if ("Notification" in window) {
                        permissionStatus = await Notification.requestPermission();
                    } else {
                        console.warn("Notification API not supported on this browser");
                        return;
                    }
                }

                console.log("permissionStatus", permissionStatus);
                if (permissionStatus.receive === "granted" || permissionStatus === "granted") {
                    setPermStatus({ receive: "granted" });
                    const token = getDeviceToken();
                    if (token) {
                        saveTokenFn.mutate(token);
                    } else {
                        setShowNotificationService(true);
                    }
                } else {
                    setShowModal({
                        ...showModal,
                        state: true,
                        type: "Error",
                        message: "Please Unblock Notification Request Manually, To receive your updates from footprints",
                    });
                }
            } catch (err) {
                console.error("Notification permission error", err);
            }
        }
    };

    const showBellIcon = permStatus?.receive === "granted" && dbDeviceToken;

    return (
        <div className="bg-white border-b sticky top-0 z-10">
            {/* <NotificationService /> */}
            <div className="flex items-center justify-between p-4">
                <h1 className="text-xl font-black tracking-wider" style={{ color: '#00BCD4' }}>
                    FOOTPRINTS
                </h1>

                {childlist?.length > 1 && (
                    <Dropdown
                        options={childlist.map((c) => ({
                            id: c.id,
                            label: `${c.gender === 1 ? "👦" : "👧"} ${c.name}`,
                            value: c
                        }))}
                        value={`${activeChild?.gender === 1 ? "👦" : "👧"} ${activeChild?.name}`}
                        selectedId={activeChild?.id}
                        onChange={(selected, index) => handleChildChange({ target: { value: index } })}
                        className="w-28"
                    />
                )}

                <div className="flex items-center space-x-3">
                    <button onClick={handleNotificationClick} className="relative">
                        {showBellIcon ? (
                            <Bell className="w-6 h-6 text-gray-600" />
                        ) : (
                            <BellOff className="w-6 h-6 text-red-500" />
                        )}
                        {bellStatus && showBellIcon && (
                            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
                        )}
                    </button>

                    {showNotificationService && <NotificationService />}

                    {activeChild?.child_photo && !imageError ? (
                        <img
                            src={getFullPath(constantsValues, activeChild.child_photo)}
                            onClick={() => navigate('/profile')}
                            alt={activeChild.name}
                            onError={() => setImageError(true)}
                            className="w-12 h-12 rounded-full object-cover border-2 border-cyan-500 cursor-pointer"
                        />
                    ) : (
                        <button
                            onClick={() => navigate('/profile')}
                            className="w-12 h-12 bg-gradient-to-br from-orange-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold"
                        >
                            {activeChild?.name?.[0] || ''}{activeChild?.last_name?.[0] || ''}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TopBar;
